import { SCENE_OBJECT_TYPES } from "../../constants/SceneObjects";
import { tourID } from "../../setScene";
import { ONE_ON_ONE_UI } from "../Controllers/constants";

export default class AutoRotateController {
  constructor(scene3d, model) {
    this.scene3d = scene3d;
    this.model = model;
    this.controls = scene3d.controls;
    this.autoRotateTimeout = null;
    this.isAutoRotateEnabled = false;

    // Initialize auto-rotation settings
    this.autoRotateSpeed = 0.2;
    this.idleTimeout = 30000; // 30 seconds after user interaction
    this.initTimeout = 10000; // 10 seconds initial delay

    // Bind event handlers
    this.handleUserInteraction = this.handleUserInteraction.bind(this);
    this.startAutoRotate = this.startAutoRotate.bind(this);
    this.stopAutoRotate = this.stopAutoRotate.bind(this);

    // Add event listeners
    this.addEventListeners();
    // Start initial timer
    this.startInitialTimer();
  }

  addEventListeners() {
    // Track user interactions
    this.model.addEventListener(ONE_ON_ONE_UI.UI_CHANGE, () => {
      if (this.model.activeOneOnOneCall) {
        this.start();
      } else {
        this.stop();
      }
    });
    window.addEventListener('pointerdown', this.handleUserInteraction);
    window.addEventListener('pointerup', this.handleUserInteraction);
    window.addEventListener('keydown', this.handleUserInteraction);
  }

  startInitialTimer() {
    this.autoRotateTimeout = setTimeout(() => {
      if (this.scene3d.enableDeviceOrientationControl) {
        return;
      }
      this.start();
    }, this.initTimeout);
  }

  handleUserInteraction() {
    this.stop();
    if (this.autoRotateTimeout) {
      clearTimeout(this.autoRotateTimeout);
      this.autoRotateTimeout = null;
    }
    this.autoRotateTimeout = setTimeout(() => {
      this.startAutoRotate();
    }, this.idleTimeout); // Use 30 second timeout after any interaction
  }

  start() {
    this.controls.update();
    this.isAutoRotateEnabled = true;
    this.startAutoRotate();
  }

  stop() {
    this.controls.update();
    this.isAutoRotateEnabled = false;
    this.stopAutoRotate();
  }

  isEnabled() {
    return this.isAutoRotateEnabled;
  }

  startAutoRotate() {
    if (this.scene3d.enableDeviceOrientationControl) {
      this.controls.autoRotate = false;
      this.controls.update();
      return;
    }
    const tour = this.model.iAmInTour();
    let iStream = false;
    this.scene3d.filtered3DObjects["screenStream"] && this.scene3d.filtered3DObjects["screenStream"].forEach((item) => {
      if (item.state && item.state.me) {
        iStream = true;
      }
    });
    this.scene3d.filtered3DObjects["guestSeat"] && this.scene3d.filtered3DObjects["guestSeat"].forEach((item) => {
      if (item.state && item.state.me) {
        iStream = true;
      }
    });
    if (iStream || tour) {
      this.controls.autoRotate = false;
      this.controls.update();
      return;
    }

    // Clear any existing timeout
    if (this.autoRotateTimeout) {
      clearTimeout(this.autoRotateTimeout);
    }
    this.autoRotateTimeout = setTimeout(() => {
      this.startAutoRotate();
    }, this.idleTimeout); // Use 30 second timeout after any interaction

    // Set auto-rotate properties
    this.controls.autoRotate = true;
    this.controls.autoRotateSpeed = this.autoRotateSpeed;
    this.controls.update();
  }

  stopAutoRotate() {
    this.controls.autoRotate = false;
    this.controls.update();

    // Clear any existing timeout
    if (this.autoRotateTimeout) {
      clearTimeout(this.autoRotateTimeout);
    }
  }

  destroy() {
    // Remove event listeners
    window.removeEventListener('pointerdown', this.handleUserInteraction);
    window.removeEventListener('keydown', this.handleUserInteraction);

    // Clear any existing timeout
    if (this.autoRotateTimeout) {
      clearTimeout(this.autoRotateTimeout);
    }

    // Stop auto-rotation
    this.stopAutoRotate();
  }
} 